(() => {
  const desktopQuery = window.matchMedia('(min-width: 990px)');
  const boundMenus = new WeakSet();
  const boundSearchPanels = new WeakSet();

  const closeMegaMenus = (exceptMenu = null) => {
    document.querySelectorAll('.site-header__mega[open]').forEach((menu) => {
      if (menu !== exceptMenu) {
        menu.removeAttribute('open');
      }
    });
  };

  const bindMegaMenus = () => {
    document.querySelectorAll('.site-header__mega').forEach((menu) => {
      if (boundMenus.has(menu)) {
        return;
      }

      boundMenus.add(menu);

      menu.addEventListener('toggle', () => {
        if (!desktopQuery.matches || !menu.open) {
          return;
        }

        closeMegaMenus(menu);
      });
    });
  };

  bindMegaMenus();
  document.addEventListener('shopify:section:load', bindMegaMenus);

  const resultIcon = `
    <span class="site-header__search-result-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none">
        <path d="M6 3.75h9l3 3v13.5H6V3.75Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
        <path d="M15 3.75V7h3" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
        <path d="M8.75 11h6.5M8.75 14h6.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
      </svg>
    </span>
  `;

  const escapeHtml = (value) => {
    const element = document.createElement('span');
    element.textContent = value || '';
    return element.innerHTML;
  };

  const highlightMatch = (title, query) => {
    const safeTitle = escapeHtml(title);

    if (!query) {
      return safeTitle;
    }

    const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return safeTitle.replace(new RegExp(`(${escapedQuery})`, 'ig'), '<strong>$1</strong>');
  };

  const getResultMeta = (result) => {
    return result.product_type || result.vendor || result.type || result.object_type || '';
  };

  const createResultMarkup = (result, query) => {
    const title = result.title || result.text || '';
    const url = result.url || `/search?q=${encodeURIComponent(title)}`;
    const imageUrl = result.image?.url || result.featured_image?.url;
    const imageAlt = result.image?.alt || title;
    const meta = getResultMeta(result);

    return `
      <a class="site-header__search-result" href="${escapeHtml(url)}">
        ${
          imageUrl
            ? `<img class="site-header__search-result-media" src="${escapeHtml(imageUrl)}" alt="${escapeHtml(imageAlt)}" loading="lazy">`
            : resultIcon
        }
        <span class="site-header__search-result-title">
          ${highlightMatch(title, query)}
          ${meta ? `<span class="site-header__search-result-meta"> - ${escapeHtml(meta)}</span>` : ''}
        </span>
      </a>
    `;
  };

  const renderSearchResults = (container, results, query) => {
    const items = [
      ...(results.products || []),
      ...(results.queries || []),
      ...(results.pages || []),
      ...(results.articles || []),
    ].slice(0, 6);

    if (!query) {
      container.innerHTML = '';
      return;
    }

    if (!items.length) {
      container.innerHTML = '<p class="site-header__search-empty">No matches found.</p>';
      return;
    }

    container.innerHTML = items.map((item) => createResultMarkup(item, query)).join('');
  };

  const fetchSearchResults = async (container, query, controller) => {
    if (!query) {
      renderSearchResults(container, {}, query);
      return;
    }

    const params = new URLSearchParams({
      q: query,
      'resources[type]': 'product,page,article,query',
      'resources[limit]': '6',
      'resources[options][unavailable_products]': 'last',
      section_id: 'predictive-search',
    });

    try {
      const response = await fetch(`/search/suggest.json?${params.toString()}`, {
        signal: controller.signal,
      });

      if (!response.ok) {
        throw new Error('Search failed');
      }

      const data = await response.json();
      renderSearchResults(container, data.resources?.results || {}, query);
    } catch (error) {
      if (error.name !== 'AbortError') {
        container.innerHTML = '<p class="site-header__search-empty">Search is unavailable right now.</p>';
      }
    }
  };

  const bindSearch = () => {
    document.querySelectorAll('.site-header').forEach((header) => {
      const panel = header.querySelector('.site-header__search-panel');

      if (!panel || boundSearchPanels.has(panel)) {
        return;
      }

      boundSearchPanels.add(panel);

      const toggle = header.querySelector('.site-header__search-toggle');
      const input = panel.querySelector('.site-header__search-input');
      const closeButton = panel.querySelector('.site-header__search-close');
      const results = panel.querySelector('[data-search-results]');
      let debounceTimer;
      let activeController;

      const openSearch = () => {
        closeMegaMenus();
        panel.hidden = false;
        toggle?.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(() => input?.focus());
      };

      const closeSearch = () => {
        panel.hidden = true;
        toggle?.setAttribute('aria-expanded', 'false');
        activeController?.abort();
      };

      toggle?.addEventListener('click', () => {
        if (panel.hidden) {
          openSearch();
        } else {
          closeSearch();
        }
      });

      closeButton?.addEventListener('click', closeSearch);

      input?.addEventListener('input', () => {
        clearTimeout(debounceTimer);
        activeController?.abort();

        const query = input.value.trim();

        debounceTimer = setTimeout(() => {
          activeController = new AbortController();
          fetchSearchResults(results, query, activeController);
        }, 180);
      });

      document.addEventListener('click', (event) => {
        if (panel.hidden || header.contains(event.target)) {
          return;
        }

        closeSearch();
      });
    });
  };

  bindSearch();
  document.addEventListener('shopify:section:load', bindSearch);

  document.addEventListener('click', (event) => {
    if (!desktopQuery.matches || event.target.closest('.site-header__mega')) {
      return;
    }

    closeMegaMenus();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') {
      return;
    }

    closeMegaMenus();

    document.querySelectorAll('.site-header__search-panel:not([hidden])').forEach((panel) => {
      panel.hidden = true;
      panel.closest('.site-header')?.querySelector('.site-header__search-toggle')?.setAttribute('aria-expanded', 'false');
    });
  });
})();
